<div class="dashboard-content-sec">
    <div class="card">
        <app-breadcrumb [crumbList]="crumbList"></app-breadcrumb>
        <div class="user-heading-sec">
            <p style="width:160px">{{this.total}} Partners</p> 

            <nav class="navbar-collapse" style="border: none;">
              <div style='width: 120px'>
                <a href="javascript:void(0)" [routerLink]="['/admins/partner']" 
                   class="btn btn-default fa fa-address-book"  style="width: 130px">
                    Add Partner
                </a>                        
              </div>

            </nav>
        </div>
        <div class="table-responsive">
          <div class="loader" *ngIf="showloader">
            <img src="assets/images/loader.gif" alt="">
          </div>
            <table class="table user-table table-striped" >
                <thead>
                    <tr>
                        <th *ngFor="let header of row_header;let i = index" (click)="tableSort(i)">
                            <i *ngIf="header.sort == 'asc' && header.value != ''" class="fa fa-sort-up"></i>
                            <i *ngIf="header.sort == 'desc' && header.value != ''" class="fa fa-sort-down"></i>
                            <i *ngIf="header.sort == null && header.value != ''" class="fa fa-sort"></i>
                            {{header.text}}
                        </th>
                      <th>Action</th>
                    </tr>
                    <tr>
                        <th>
                            <div class="subject-search">
                                <input (change)="filterByPartner($event)"/>
                            </div>
                        </th>
                        <th>
                            <div class="subject-search">
                                <input (change)="filterByContactName($event)"/>
                            </div>
                        </th>
                        <th>&nbsp;</th>
                        <th>&nbsp;</th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>

                <tbody>
                    <ng-container *ngFor="let partner of partners">
                        <tr>
                        
                            <td>
                                <a href="javascrpt:void(0);" [routerLink]="['/admins/partner',partner.ID]">{{partner.CompanyName}}</a>
                            </td>
                            
                            <td>
                                <a href="javascrpt:void(0);" [routerLink]="['/admins/partner',partner.ID]">{{partner.ContactName}}</a>
                            </td>
                            <td>
                                <a href="javascrpt:void(0);" [routerLink]="['/admins/partner',partner.ID]">{{partner.Status==1 ? "Active" : 'Inactive'}}</a>
                            </td>
        
                            <td>
                            <a href="javascrpt:void(0);" [routerLink]="['/admins/partner',partner.ID]">{{partner.Notes ? partner.Notes.substring(0,30) : '-'}}</a>
                            </td>
        
                            <td>
                                <div ngbDropdown placement="bottom-right" class="d-inline-block">
                                    <button class="" id="dropdownBasic1" ngbDropdownToggle><i class="fa fa-ellipsis-h" aria-hidden="true"></i>
                                    </button>
                                    <div class="right" ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                        <button class="dropdown-item" [routerLink]="['/admins/partner',partner.ID]">Edit</button>
                                        <button class="dropdown-item" (click)="deleteUser(partner.ID)">Delete</button>
                                    </div>
                                </div>
                            </td>
                        </tr>

                    </ng-container>
                </tbody>

                <ng-container *ngIf="partners?.length == 0">
                  <tr><td colspan="5">No Result Found</td></tr>
                </ng-container>



            </table>
            <div class="has-text-centered align-items-end">
                <ul *ngIf="pager.pages && pager.pages.length && pager.pages.length>1" class="pagination">
                    <li *ngIf="pager.currentPage !== 1" [ngClass]="{disabled:pager.currentPage === 1}">
                        <a (click)="setPage(1)">First</a>
                    </li>
                    <li *ngIf="pager.currentPage !== 1" [ngClass]="{disabled:pager.currentPage === 1}">
                        <a (click)="setPage(pager.currentPage - 1)">Previous</a>
                    </li>
                    <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                        <a (click)="setPage(page)">{{page}}</a>
                    </li>
                    <li *ngIf="pager.currentPage !== pager.totalPages" [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                        <a (click)="setPage(pager.currentPage + 1)">Next</a>
                    </li>
                    <li *ngIf="pager.currentPage !== pager.totalPages" [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                        <a (click)="setPage(pager.totalPages)">Last</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
